import { styled, Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import { Bold, rem } from '@core-web/typography';

export enum CHECKBOX_CHANGE_COLOR {
  DANGER = 'red',
  WARNING = 'orange',
}

interface CheckBoxProp extends CheckboxProps {
  customSize: number;
  checkBoxChangeColor?: CHECKBOX_CHANGE_COLOR;
  padding?: number;
}

const getCheckboxChangeColor = (theme: any, changeColor?: CHECKBOX_CHANGE_COLOR) => {
  switch (changeColor) {
    case CHECKBOX_CHANGE_COLOR.DANGER:
      return theme.palette.colors.red;

    case CHECKBOX_CHANGE_COLOR.WARNING:
      return theme.palette.colors.orange_400;

    default:
      return theme.palette.colors.blue_700;
  }
};

export const CheckboxButtonStyled = styled(FormControlLabel)<CheckboxProps>(({ theme: { palette }, label }) => ({
  justifyContent: 'left',
  marginLeft: rem(0),
  ...(!label && { marginRight: rem(0) }),
  //width: 'max-content',
  width: '100%',
  '& span.MuiFormControlLabel-label': {
    color: palette.colors.grey_900,
    fontWeight: Bold._500,
    fontSize: rem(14),
  },
}));

export const MuiCheckBox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'customSize' && prop !== 'checkBoxChangeColor',
})<CheckBoxProp>(({ theme, customSize, checkBoxChangeColor, padding }) => ({
  color: theme.palette.colors.blue_700,
  borderRadius: rem(4),
  ...(padding && { padding: rem(padding) }),
  '& .MuiSvgIcon-root': { fontSize: customSize },
  '&.Mui-checked': {
    color: getCheckboxChangeColor(theme, checkBoxChangeColor),
  },
  '&.errorBorder': {
    color: theme.palette.error.main,
  },
}));
